export default __webpack_public_path__ + "static/media/empty-voicemail.89e1972c.svg";